module.exports = __webpack_public_path__ + "static/img/600x600-HOME-2.5307f44b.jpg";